export default function(){let size=0;for(const node of this)++size;return size}